export const REACT_RENDER_OP = 'ui.react.render';

export const REACT_UPDATE_OP = 'ui.react.update';

export const REACT_MOUNT_OP = 'ui.react.mount';
